// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"b2-z","colorTextValue":"c2-z","swatches":"d2-z","collapseLink":"e2-z","isCollapsed":"f2-z","dropdown":"g2-z","disabled":"h2-z"};